<template>
  <el-dialog
    title="提示"
    append-to-body
    :visible.sync="visible"
    width="886px"
    :lock-scroll="false"
    destroy-on-close
    @close="onclose"
  >
    <div style="width: 100%; height: 646px">
      <div class="dialogHeader">
        <div class="dialogHeader__title">
          {{ $t("bigScreen.在线设备列表") }}
        </div>
        <i class="el-icon-close" @click="visible = false"></i>
      </div>
      <div style="height: calc(100% - 100px)">
        <base-loading :loading="loadingList" background="transparent">
          <el-table
            class="mrt-20"
            stripe
            :data="zxsbDataList"
            style="width: 100%"
            :cell-style="cellStyle"
            @row-click="toDetail"
          >
            <template slot="empty">
              <base-empty :description="$t('bigScreen.暂无数据')"></base-empty>
            </template>
            <el-table-column
              :index="indexMethod"
              type="index"
              :label="$t('bigScreen.序号')"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="qymc"
              :label="$t('bigScreen.客户名称')"
              width="160"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="sbgk" :label="$t('bigScreen.型号')">
            </el-table-column>
            <el-table-column prop="sbmc" :label="$t('bigScreen.设备名称')">
            </el-table-column>
            <el-table-column prop="gzztmc" :label="$t('bigScreen.工作状态')">
              <template slot-scope="scope">
                <span>{{
                  scope.row.gzztmc ? $t("detailScreen." + scope.row.gzztmc) : ""
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="updateTime"
              :label="$t('bigScreen.更新时间')"
              show-overflow-tooltip
            >
            </el-table-column>
          </el-table>
        </base-loading>
        <div class="pagination">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-size="pageSize"
            layout="total, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getZxsblb } from "@/api/dpIndex";
import { Message } from "element-ui";

export default {
  name: "zxsb-dialog",
  props: {
    showDialog: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      visible: false,
      loadingList: false,
      zxsbDataList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
    };
  },
  watch: {
    showDialog() {
      this.visible = this.showDialog;
    },
  },
  created() {
    this.visible = this.showDialog;
    this.init();
  },
  methods: {
    init() {
      this.getZxsblb();
    },
    cellStyle() {
      return "cursor:pointer;";
    },
    toDetail(data) {
      if (data.gzztdm === "") {
        Message.error(this.$t("detailScreen.该设备异常"));
        return;
      }
      this.onclose();
      this.$router.push({
        path: "/detail",
        query: {
          sbxxid: data.sbxxid,
        },
      });
    },
    indexMethod(index) {
      return index + 1 + this.pageSize * (this.pageNum - 1);
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getZxsblb();
    },
    onclose() {
      this.zxsbDataList = [];
      this.total = 0;
      this.pageNum = 1;
      this.$emit("close");
    },
    async getZxsblb() {
      this.zxsbDataList = [];
      this.loadingList = true;
      let params = {
        token: this.$store.state.user.token,
        gzztgl: "1",
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      getZxsblb(params).then((result) => {
        this.zxsbDataList = result.rows;
        this.total = result.total;
        this.loadingList = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  background: #010d37;
  box-shadow: inset 0px 0px 22px 0px rgba(104, 232, 255, 0.7);
  border: 2px solid rgba(104, 232, 255, 0.3);
}
/deep/.el-dialog__header {
  display: none;
}
.dialogHeader {
  width: 100%;
  height: 40px;
  background: url("@/assets/images/header.png");
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 28px;
  &__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 22px;
    color: #68e8ff;
    line-height: 22px;
  }
  i {
    font-size: 12px;
    color: #37ccfd;
    cursor: pointer;
  }
}
/deep/.el-pagination__total {
  color: #ffffff;
}
/deep/.el-pagination button {
  background-color: transparent;
  border: 1px solid #007ee1;
  &:disabled {
    background-color: transparent;
  }
}
/deep/.el-pagination .btn-next {
  color: #fff;
}
/deep/.el-pagination .btn-prev {
  color: #fff;
}

/deep/.el-pager li {
  background: transparent;
  border: 1px solid #007ee1;
  color: #fff;
  &.active {
    color: #fff;
    background: rgba(0, 126, 225, 1);
  }
}
/deep/.el-pagination__jump {
  color: #fff;
}
/deep/.el-pagination__editor.el-input .el-input__inner {
  background: transparent;
  border: 1px solid #007ee1;
  color: #fff;
}
.pagination {
  margin-top: 12px;
  text-align: right;
}
</style>
